var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.RemenLuxianDetailData)?_c('div',{staticClass:"container"},[_c('Header',{attrs:{"status":"simple"}}),_c('RemenLuxian',{attrs:{"RemenLuxianDetailData":_vm.RemenLuxianDetailData}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }